// EDIT THIS TEXT FOR FINAL COPY
// This file contains all editable content for the EGTA 2025 main conference download page

export const EGTA_2025_CONTENT = {
  // Page metadata
  pageTitle: 'EGTA 2025 Session Materials | Syllepsis',
  pageDescription: 'Access your EGTA 2025 conference session materials',
  
  // Page header
  headerTitle: 'EGTA 2025 Session Materials',
  headerSubtitle: 'Enter your details below to receive the conference materials by email',
  
  // Form labels and validation
  form: {
    nameLabel: 'Full Name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Work Email',
    emailPlaceholder: 'your.email@company.com',
    consentLabel: 'I agree to receive these materials by email and to be contacted by Syllepsis about related services.',
    submitButton: 'Send Materials',
    submittingButton: 'Sending...',
  },
  
  // Success/Error messages
  messages: {
    success: 'Thanks! Your documents are on their way. Check your inbox.',
    error: '⚠️ Oops, something went wrong. Please try again or email us at info@syllepsis.io.',
  },
  
  // Email configuration
  email: {
    subject: 'Your EGTA 2025 session materials',
    greeting: (firstName: string) => `Hi ${firstName},`,
    body: `
      <p>Thank you for your interest in our EGTA 2025 presentation.</p>
      <p>Attached you'll find the following materials from our session:</p>
      <ul>
        <li>Session Overview</li>
        <li>Demo Scripts</li>
        <li>Knowledge Framework</li>
        <li>Case Notes</li>
        <li>Pricing Prompt</li>
      </ul>
      <p>If you have any questions or would like to discuss how we can help your organization, please don't hesitate to reach out.</p>
    `,
    signature: `
      <p>Best regards,<br>
      The Syllepsis Team<br>
      <a href="mailto:info@syllepsis.io">info@syllepsis.io</a></p>
    `,
  },
  
  // PDF filenames (these will be looked for in /public/docs/egta-2025/)
  attachments: [
    'EGTA_Session_Overview.pdf',
    'Demo_Scripts.pdf',
    'Knowledge_Framework.pdf',
    'Case_Notes.pdf',
    'Pricing_Prompt.pdf',
  ],
};
